import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';

const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const FlickerBox = styled('div')({
  // backgroundColor: 'pink',
  animation: `${blink} 1s linear(0 0%, 1 50%, 1 100%) infinite`,
});
export default FlickerBox;
